import { ElaborationStatusItem } from "../redux/feature/object/remote-elaborations-slice";
import { formatMessage } from "../utils/helpers/LanguageHelper";
import PanelStandaloneManager from "../common/panelStandaloneModal/PanelStandaloneManager";
import { DownloadResponse, saveFile } from "../utils/DownloadHelper";

export async function handleCheckDifferencesResult(item: ElaborationStatusItem) {
  if (!item.outputResponse) return;

  const response = JSON.parse(item.outputResponse) as DownloadResponse;

  if (item.status === "COMPLETED" && response) {
    if (!response.base64Content) {
      PanelStandaloneManager.addPanelStandalone({
        key: "exportdifferences_nodifferences",
        modalTitle: formatMessage("cof.exportdifferences.nodifferences.title"),
        message: formatMessage("cof.exportdifferences.nodifferences.message"),
        icon: "/assets/allChecksValid.svg",
        type: "delete",
        actions: [
          {
            id: "back_button",
            title: formatMessage("cof.base.back"),
            onClick: () => {},
            variant: "blue",
          },
        ],
      });
      return;
    }
    saveFile(response);
    return;
  }
  console.error("Error Saving File", item.messages);
  return Promise.reject(new Error(formatMessage("cof.exportdifferences.error")));
}
